import { useToast } from 'src/contexts/toast';
import styles from './index.sass';
import cls from 'src/utils/class_names';
import { Link } from 'react-router-dom';

function Toasts({ rtl = false }) {
	const { toasts, closeToast } = useToast();

	const handleClose = (toast) => {
		if (toast?.options?.closable) {
			closeToast(toast.id);
		}
	};

	return (
		<div className={cls(styles.toasts, rtl && styles.rtl)}>
			{toasts.map((toast) => (
				<div
					key={toast.id}
					className={cls(styles.toast, styles[toast.options.state], styles[toast.options.type])}
					style={{ '--color': toast.options.color } as any}
					onClick={(e) => {
						e.stopPropagation();
						handleClose(toast);
					}}
				>
					<header>
						<i className={`icon ${styles.icon} ${toast.options.icon}`}></i>

						<div className={styles.title}>{toast.title}</div>

						{toast.options.actions.length > 0 && (
							<div className={styles.actions}>
								{toast.options.actions.map((action, index) =>
									action.url ? (
										<Link key={`action-${index + 1}`} to={action.url}>
											<button
												className={styles.action}
												style={{ '--color': action.color } as any}
												onClick={(e) => {
													e.stopPropagation();
												}}
											>
												{action.title}
											</button>
										</Link>
									) : (
										<button
											key={`action-${index + 1}`}
											className={styles.action}
											style={{ '--color': action.color } as any}
											onClick={(e) => {
												e.stopPropagation();
												action.handler(e);
											}}
										>
											{action.title}
										</button>
									)
								)}
							</div>
						)}
					</header>

					<p className={styles.message}>{toast.message}</p>
				</div>
			))}
		</div>
	);
}

export default Toasts;
